import { EProvince } from '../income'

export interface IExpense {
	id: string
	_id: string
	province?: EProvince
	federalBudget: string
	institutionBudget?: string
	entityBudget?: string
	programBudget?: string
	institution?: Entities.Institution.Object
	entity?: Entities.Entity.Object
	program?: Entities.Program.Object
	type: EExpenseType
	level: EExpenseLevel
	amount: number
	destinationType: string
	destinationName: string
	destinationNature: string
	destinationID: string
	note: string
	date: Date
	year: number
	quarter: number
	metadata: {
		createdAt: Date
		updatedAt: Date
	}
}

export interface INewExpense {
	id: string
	_id: string
	area: EEntityArea
	province?: EProvince
	amount: number
	type: EExpenseType
	parentEntity: any
	fundingEntities: any[]
	parentBudget: string
	budgets: string[]
	destinationType: EExpenseType
	destinationName: string
	destinationNature: EExpenseDestinationNature
	destinationID: string
	note: string
	timestamps: {
		createdAt: Date
		updatedAt: Date
	}
}

export enum EEntityArea {
	NationalGovernment = 'national-government',
	DecentralizedInstitution = 'decentralized-institution',
	PublicCompany = 'public-company',
	Program = 'program',
	Project = 'project',
	SubEntity = 'sub-entity',
	Municipality = 'municipality',
}

export enum EExpenseLevel {
	Federal = 'federal',
	Quarter = 'quarter',
	Institution = 'institution',
	Entity = 'entity',
	Program = 'program',
}

export enum EExploreExpensesExtraLevel {
	List = 'list',
	Discrete = 'discrete',
}

export type EExploreExpensesLevel = EExpenseLevel | EExploreExpensesExtraLevel
export enum EExpenseType {
	Capital = 'capital',
	Corriente = 'corriente',
}

export enum EExpenseDestinationNature {
	Privado = 'privado',
	Particular = 'particular',
	Publico = 'público',
}

export enum EDestinationTypeCorriente {
	Operacion = 'operación',
	TransferenciasCorrientes = 'transferencias-corrientes',
	Subsidios = 'subsidios',
	InteresDeLaDeuda = 'interés-de-la-deuda',
}

export enum EDestinationTypeCapital {
	Inversiones = 'inversiones',
	OtrosGastosDeCapital = 'otros-gastos-de-capital',
	TransferenciasDeCapital = 'transferencias-de-capital',
	AmortizacionDeLaDeuda = 'amortización-de-la-deuda',
}
